module.exports = {
  messages: {
    CN: {
      "login.useraccountPH": "请输入用户名",
      "login.pwdPH": "请输入密码",
      "login.captchaPH": "请输入验证码",
      "login.login": "登录",
      "login.inputfee": "请输入手续费",
      "login.addfee": "新建手续费",
      "login.editfee": "编辑手续费"
    },
    JP: {
      "login.useraccountPH": "ユーザー名を入力してください",
      "login.pwdPH": "パスワードを入力してください",
      "login.captchaPH": "認証コードを入力してください",
      "login.login": "ログイン",
      "login.inputfee": "请输入手续费",
      "login.addfee": "新建手续费",
      "login.editfee": "编辑手续费"
    }
  }
};